export const hashById = <FROM extends ({_id?:any}|undefined),TO=FROM>( values:FROM[], hasher?:(value:FROM)=>TO ) : Record<string,TO> => {
    return values.reduce( (hash,value) => {
        if( value )
            hash[String(value._id)] = hasher ? hasher(value) : value as unknown as TO;
        return hash;
    },{} as Record<string,TO>);
}

export default hashById;